<template>
  <section>
    <PageHeading title="Editar usuários" :pieces="['Usuários', 'Editar usuários']" />
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Clique nos campos e edite conforme necessário</h5>
            <div class="ibox-tools">
              <ul class="dropdown-menu dropdown-user">
                <li>
                  <a href="#">Config option 1</a>
                </li>
                <li>
                  <a href="#">Config option 2</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="ibox-content">
            <table class="table table-striped table-bordered table-hover" id="editable">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>E-mail</th>
                  <th>Criado por</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody></tbody>
              <tfoot>
                <tr>
                  <th>Nome</th>
                  <th>E-mail</th>
                  <th>Criado por</th>
                  <th>Ações</th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */
import "datatables.net";
import "datatables.net-bs";
import * as firebase from "firebase/app";
import "firebase/firestore";
import { mapGetters } from "vuex";
import PageHeading from "@/views/admin/components/PageHeading.vue";
import { deleteMasterByEmail } from '@/services/admin';

export default {
  computed: {
    ...mapGetters(["userData"]),
  },
  components: {
    PageHeading,
  },
  methods: {
    buildTable(buttons, tb) {
      let $table = tb;
      Array.from(buttons).forEach((button) => {
        button.addEventListener(
          "click",
          async (e) => {
            const email = e.target.dataset.masterEmail;

            if (
              !confirm(`Tem certeza que deseja excluir o usuário ${email}?`)
            ) {
              return;
            }

            try {
              await deleteMasterByEmail(email);
              const filtered = this.$data.masters.filter(
                (master) => master.email === email
              )[0];
              this.$data.masters.splice(
                this.$data.masters.indexOf(filtered),
                1
              );

              const source = this.getSource();
              this.$data.bindEvents = true;
              $table.clear();
              $table.rows.add(source);
              $table.draw();
            } catch (e) {
              alert('Houve um erro inesperado ao excluir o usuário.');
            }
          },
          false
        );
      });
      this.$data.bindEvents = false;
    },

    getSource() {
      return this.$data.masters.map((masterData) => {
        return [
          masterData.name,
          masterData.email,
          masterData.creatorId ? masterData.creatorId : "----",
          `<a class="btn btn-danger btn-sm delete-master" data-master-email="${masterData.email}" href="javascript:void(0)" style="font-weight: bolder;">EXCLUIR</a>`,
        ];
      });
    },
  },
  data() {
    return {
      bindEvents: false,
      tableElem: null,
      masters: [],
    };
  },
  async mounted() {
    const mastersSnapshot = await firebase
      .firestore()
      .collection("admin")
      .get();

    this.$data.masters = [];
    mastersSnapshot.docs.forEach((docSnapshot) => {
      if (docSnapshot.data().email !== this.userData.email)
        this.$data.masters.push(docSnapshot.data());
    });

    const source = this.getSource();

    let $table = $("#editable").DataTable({
      data: source,
      initComplete:  () => {
        const buttons = document.querySelectorAll(".delete-master");
        Array.from(buttons).forEach((button) => {
          button.addEventListener(
            "click",
            async (e) => {
              const email = e.target.dataset.masterEmail;

              if (
                !confirm(`Tem certeza que deseja excluir o usuário ${email}?`)
              ) {
                return;
              }

              try {
                await deleteMasterByEmail(email);

                const filtered = this.$data.masters.filter(
                  (master) => master.email === email
                )[0];
                this.$data.masters.splice(
                  this.$data.masters.indexOf(filtered),
                  1
                );

                const source = this.getSource();
                this.$data.bindEvents = true;
                $table.clear();
                $table.rows.add(source);
                $table.draw();
              } catch (e) {
                console.log(e);
                alert('Houve um erro inesperado ao excluir o usuário.');
              }
            },
            false
          );
        });
        this.$data.bindEvents = false;
      },
      language: {
        search: "Buscar:",
        sLengthMenu: "Mostrar _MENU_  registros por página",
        sInfo: "Exibindo _START_ a _END_ de _TOTAL_ registros",
        sZeroRecords: "A busca não retornou resultados.",
        sInfoFiltered: "(filtrados de um total de _MAX_ registros)",
        sInfoEmpty: "Nenhum registro encontrado!",
        paginate: { previous: "Anterior", next: "Próxima" },
      },
    });

    this.$data.tableElem = $table;

    $table.on("draw", () => {
      if (this.$data.bindEvents) {
        const buttons = document.querySelectorAll(".delete-master");
        this.buildTable(buttons, $table);
      }
    });
  },
};
</script>


<style lang="scss">
#editable_length {
  select[name="editable_length"] {
    padding: 0 !important;
    padding: {
      left: 10px !important;
      right: 10px !important;
    }
  }
}

#editable_filter {
  label {
    display: flex;
    width: 100%;
    align-items: center;

    input {
      flex: 1;
      margin-left: 5px;
    }
  }
}
</style>
